import React, { useEffect, useState } from "react";
import "./styles.scss";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { CreateNewAdvertisement, CreateNewGazette } from "../CreateNewItem";
import { AdvCampaignCard, Button, DropBox, FormHeader } from "../../components";
import "./styles.scss";
import Scrollbars from "react-custom-scrollbars-2";
import { useDispatch, useSelector } from "react-redux";
import { setCampaign, setCampaignList } from "./redux/actions";
import {
  deleteAdvertisement,
  getAllAdvertisement,
  updateAdvertisementStatus,
} from "../CreateNewItem/CreateNewAdvertisement/service/advertisement.service";
import moment from "moment";
import AdminGazetteCard from "../../components/adminGazetteCard";
import {
  deleteGazette,
  getAllGazette,
} from "../CreateNewItem/CreateNewGazette/service/jobs.service";
import { setGazetteList } from "../Jobs/redux/actions";
import { getInsight, getLanguage } from "../../utils";
import { Store } from "react-notifications-component";

const lan = getLanguage();

const Gazette = () => {
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [formData, setFormData] = useState({
    category: {
      key: "category",
      label: "",
      size: "lg",
      placeholder: "select category",
      mainLayerStyles: " flex-column " + " align-content-center ",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const [selectCampaign, setSelectCampaign] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const gazetteList = useSelector((state) => state.jobsReducer.gazetteList);
  const { tagsList } = useSelector(({ tagsReducer }) => tagsReducer);

  const dispatch = useDispatch();

  const openWindow = async (imgUrl) => {
    const adUrlRight = process.env.REACT_APP_HOME_TOP_RIGHT_ADV;
    const adUrlLeft = process.env.REACT_APP_HOME_TOP_LEFT_ADV;

    const insight = await getInsight(); // Assuming this returns { insight_id }

    // const isPdf = imgUrl.endsWith(".pdf");
    let previewElement = "";
    console.log("Array.isArray(imgUrl)", Array.isArray(imgUrl));
    if (Array.isArray(imgUrl)) {
      previewElement = imgUrl
        .map((img, id) => {
          const src = img?.file_url;
          if (src?.endsWith(".pdf")) {
            return `<iframe src="${src}" alt="${id}" class="responsive-content"></iframe>`;
          } else {
            return `<img src="${src}" alt="${id}" class="responsive-content" />`;
          }
        })
        .join("");
    } else {
      previewElement = imgUrl?.endsWith(".pdf")
        ? `<iframe src="${imgUrl}" alt="PDF" class="responsive-content"></iframe>`
        : `<img src="${imgUrl}" alt="job details sinhala" class="responsive-content" />`;
    }

    const newWindow = window.open("", "", "width=1024,height=920");
    if (newWindow) {
      const safeAdUrlRight = adUrlRight || "";
      const safeAdUrlLeft = adUrlLeft || "";

      newWindow.document.write(`
      <html>
        <head>
          <title>Preview</title>
          <style>
            html, body {
              margin: 0;
              padding: 0;
              height: 100%;
              width: 100%;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
            }
  
            .advertisement-wrapper {
              display: flex;
              flex-direction: row;
              justify-content: center;
              gap: 10px;
              height: 80px;
              flex-shrink: 0;
            }
  
            .top-ad {
              flex: 1;
              height: 100%;
            }
  
            .top-ad iframe {
              width: 100%;
              height: 100%;
              border: none;
            }
  
            .content-container {
              flex: 1;
              /*overflow: auto;*/
              display: flex;
              justify-content: center;
              align-items: center;
              background: #f8f8f8;
            }
  
            .responsive-content {
              max-width: 100%;
              max-height: 100%;
              width: 100%;
              height: 100%;
              object-fit: contain;
              border: none;
            }
          </style>
        </head>
        <body>
          <div class="advertisement-wrapper">
            <div class="top-ad">
              <iframe id="adFrameLeft" src="${safeAdUrlLeft}" loading="lazy"></iframe>
            </div>
            <div class="top-ad">
              <iframe id="adFrameRight" src="${safeAdUrlRight}" loading="lazy"></iframe>
            </div>
          </div>
          <div class="content-container"  style="display: flex; flex-direction: column;">
            ${previewElement}
          </div>
          <script>
            window.addEventListener('load', function () {
              const iframeLeft = document.getElementById('adFrameLeft');
              const iframeRight = document.getElementById('adFrameRight');
  
              iframeLeft?.addEventListener('load', function () {
                iframeLeft.contentWindow?.postMessage(
                  { insight_id: "${insight?.insight_id || ""}" },
                  "${safeAdUrlLeft}"
                );
              });
  
              iframeRight?.addEventListener('load', function () {
                iframeRight.contentWindow?.postMessage(
                  { insight_id: "${insight?.insight_id || ""}" },
                  "${safeAdUrlRight}"
                );
              });
            });
          </script>
        </body>
      </html>
    `);
      newWindow.document.close();
    }
  };

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  const onClickRefresh = async () => {
    setIsLoading(true);
    try {
      const getList = await getAllGazette();
      console.log("Get All Gazette : ", getList);
      if (getList.data) {
        dispatch(setGazetteList(getList.data));
        setIsLoading(false);
      } else {
        console.log("Data Not Found");
      }
    } catch (error) {
      console.log("Error Refreshing Page", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const getList = await getAllGazette();
        console.log("Get All Gazette : ", getList);

        if (getList.data) {
          dispatch(setGazetteList(getList.data));
        } else {
          console.log("Data Not Found");
        }
      } catch (error) {
        console.log("Error fetching Campaign Data", error);
      }
    };
    fetchData();
  }, []);

  const fetchTagName = (tagId) => {
    const jobCategory = gazetteList?.find(
      (gazette) => gazette.gazette_id === tagId
    );
    return jobCategory ? jobCategory.name : "-";
  };

  const onChangeRefresh = (refresh) => {
    if (refresh) {
      setIsLoading(true);
      onClickRefresh();
    }
  };

  //get days
  const getActiveDayLabel = (schedule) => {
    if (!schedule) return "N/A";

    if (schedule.sevenDays) return "7";
    if (schedule.thirtyDays) return "30";
    if (schedule.oneTwentyEightDays) return "128";

    return "N/A";
  };

  const updateForm = { ...formData };

  return (
    <>
      <div className={"hne-gazette-wrapper"}>
        <div className={"col-7 gazette-body-wrapper"}>
          <div className={"d-flex flex-row justify-content-between"}>
            <FormHeader
              data={{
                formHeader: "Government Gazette",
                size: "md-md",
              }}
            />
          </div>

          <div className={"hne-action-wrapper"}>
            <div
              className={"hne-gw-action-wrapper"}
              style={{ marginLeft: "570px" }}
            >
              <Button
                data={{
                  btnName: "REFRESH",
                  buttonType: "border",
                  buttonSize: "sm x",
                  isLoading: isLoading,
                }}
                onClick={async (e) => {
                  e.preventDefault();
                  await onClickRefresh(e);
                }}
              />
              <Button
                data={{
                  btnName: "SEARCH",
                  buttonType: "primary",
                  buttonSize: "sm x",
                  isLoading: false,
                }}
                // onClick={async (e) => {
                //   e.preventDefault();
                //   await onClickSave(e);
                // }}
              />
            </div>
          </div>
          <div className={"hne-ga-new-body-wrapper"}>
            <Scrollbars
              onScroll={handleOnScroll}
              renderView={(props) => (
                <div
                  {...props}
                  style={{ ...props.style, overflowX: "hidden" }}
                />
              )}
              style={{ height: viewPointHeight - 230 }}
            >
              <div>
                {Array.isArray(gazetteList) && gazetteList.length > 0 ? (
                  [...gazetteList]
                    .sort(
                      (a, b) => new Date(b.created_at) - new Date(a.created_at)
                    )
                    .map((gazette) => (
                      <AdminGazetteCard
                        // isSelect={selectJobs === gazette?.gazette_id}

                        titleEn={
                          "Gazette of the Democratic Socialist Republic of Sri Lanka"
                        }
                        titleSi={
                          "ශ්‍රී ලංකා ප්‍රජාතාන්ත්‍රික සමාජවාදී ජනරජයේ ගැසට් පත්‍ර"
                        }
                        closeDate={gazette?.gazette_date}
                        created_at={gazette?.created_at}
                        tags={gazette?.tags}
                        views={gazette?.views}
                        // name={fetchOrganizationName(jobs?.organization)}
                        job_si={gazette?.job_details?.si_url}
                        job_ta={gazette?.job_details?.ta_url}
                        job_en={gazette?.job_details?.en_url}
                        procument_si={gazette?.procurement_details?.si_url}
                        procument_ta={gazette?.procurement_details?.ta_url}
                        procument_en={gazette?.procurement_details?.en_url}
                        type="admin"
                        // view="View"
                        edit="Edit"
                        delete="Delete"
                        onClickDetailsSI={async () => {
                          await openWindow(gazette?.job_details?.si_url);
                        }}
                        onClickDetailsTA={async () => {
                          await openWindow(gazette?.job_details?.ta_url);
                        }}
                        onClickDetailsEN={async () => {
                          console.log("en", gazette?.job_details?.en_url);
                          await openWindow(gazette?.job_details?.en_url);
                        }}
                        onClickProcumentSI={async () => {
                          await openWindow(
                            gazette?.procurement_details?.si_url
                          );
                        }}
                        onClickProcumentTA={async () => {
                          await openWindow(
                            gazette?.procurement_details?.ta_url
                          );
                        }}
                        onClickProcumentEN={async () => {
                          console.log(
                            "en",
                            gazette?.procurement_details?.en_url
                          );
                          await openWindow(
                            gazette?.procurement_details?.en_url
                          );
                        }}
                        // onClickEdit={() => {
                        //   setSelectJobs(jobs?.job_id);
                        //   dispatch(setJobs(jobs));
                        // }}
                        onClickRemove={async () => {
                          setIsLoading(true);
                          try {
                            let result = await deleteGazette(
                              gazette?.gazette_id
                            );
                            console.log("Delete Gazette  Result: ", result);
                            if (result?.data) {
                              Store.addNotification({
                                title: "Success",
                                message: "Gazette successfully deleted",
                                type: "success",
                                container: "top-right",
                                dismiss: {
                                  duration: 2000,
                                  onScreen: true,
                                },
                              });
                              await onClickRefresh();
                            }
                          } catch (error) {
                            console.log("Error deleting Gazette ", error);
                            Store.addNotification({
                              title: "Error",
                              message: "Failed to delete Gazette ",
                              type: "danger",
                              container: "top-right",
                              dismiss: {
                                duration: 2000,
                                onScreen: true,
                              },
                            });
                          }
                        }}
                      />
                    ))
                ) : (
                  <div className="error-message">No Gazette Found</div>
                )}
              </div>
            </Scrollbars>
          </div>
        </div>

        {/*right side*/}
        <div className={"col-5 gazette-right-side-wrapper"}>
          <CreateNewGazette refresh={onClickRefresh} />
        </div>
      </div>
    </>
  );
};
export default withRouter(Gazette);
